
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "33px",
    "height": "32px"
  },
  "children": [
    {
      "tag": "image",
      "attrsMap": {
        "x": "0px",
        "y": "0px",
        "width": "33px",
        "height": "32px",
        "xlink:href": "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAgCAQAAAA2sdlBAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkCxMCGTmz/M8qAAADa0lEQVRIx42UbWjVZRjGf2fnv+POpqu5aWqk2GLZJtXQkQbOcAstGAsKZFEofbAg6IN+iMoPBfahKHohX4gkBOmNhiwKSplSDhV0RVbqtKzly6rp3Obc5nZ2fn3YYZ39/6fW/Xy77uu57vu5nvt5kEkr8AP/O1pDOwgIxwjwJkcIgDHSpImRR5w417mLjQyHN0QlAJppA/IJmEGCFH2kSCGn2UDs/0lUMoNaKiijlCQj9HCJXzhIEXHSEXbEi51qt6qDdnnGH+3wvH2qdjtmy9ReAKRo4Vt+4CK9DJOgmNkspprllEUPEu3iffUpC8O1xMAmB/w8jOdFNGPAWQZz9tbJ9eiO3BJJckeCPJxKIkUfMOdfJIoJGJq6i9PAvcRzSixhOuemshPvtstuF+ewc67t6powHiXG3aq2eGMIz3ebutfE1BJ4q8fU3VZkYSW+7Yi/WxPl55LACtvUn93hIy63wdc9rp6xNhc7Op0xFrCIfqCccp7MygxRyWV+Dc9MbNI1l7CCeh7gNuA4e7lMOaVc5SSyhvuAK3zJPvbTmetGClxna+Z5qe7xzoyNiAt8R9V+Vdt91plhL+a6yyH1kM+4xC12OuY52232PT/ymJ2m7PVda3zcz0yrX1iVLTHbT9VTrrc0U3mpr3o488R12O/c7kqTIha72jb16LgIYtId6v5M4/+s6S62zjXWW21JKDfP3WqrZeMSa9UT3h65rnlW+6AP2+BS50eyszygvuwcnGmbI64LEW5xk0ez/u2TvhgpstKr/uZGrFe/dvakZJ1HVD3odt9wm185qp6wKSTyofo9vqRunpRo9ILaYp03TYz3Pe5S+316ErNJ7cOPHfXRLHiZZ9WtFoUqTvN59ZoNWdgdam8eN3ONnolJK2QTC4FKVlMCJCimAJhOPbVAIZu5IWvkh0kFBMjYBLicRjr4iftpZg8HqKKCi7RTQxPDfEI51aznrYn3JOBhe6zLNBbzNXWDBTbaalrV846q+o1rLXCV2mI8w5/vgJfwsFdcJQbGLPGQ/S7NePKXvT5nlU/Y5VUfcnwM//SUi8RAXOig3QFpitnCBZKMkaAaeIU+ZBalDLCMcoqJU8QLPEY+eRRSyk7+YBopikgyELOZFeRnvlsZQgqIA2kGgWkEpBlGkgSYYSQz37Yk6PgbLf18QpFbOvsAAAAASUVORK5CYII="
      }
    }
  ]
})
    }
  